module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-512x512-46d2d687565218052eff71ae7bf7791e.png";